export const MAPBOX_API_KEY = process.env.MAPBOX_API_KEY
  ? process.env.MAPBOX_API_KEY
  : "pk.eyJ1IjoieWFzaGFzdmktamFpbiIsImEiOiJjazN6c2t6NjYwNzBlM21tdDcza2F6a2RnIn0.zwJ3VLGHY_fIzpGLHV9vZg";
export const token =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IlVBLTE3NDAxIiwicGlkIjoiSjhQMzhXNEgiLCJmaXJzdF9uYW1lIjoiR2F1cmF2IiwibGFzdF9uYW1lIjoiR295YWwiLCJtb2JpbGUiOiI5MS04ODI2OTU2NTY5IiwiYXBwX2lkIjoiQjR4bEpycFAyZFBuTFZKQzhtdTJVMk1jc1NtaFpOR29janBnQ1RJTCIsInVzZXJfaWQiOiI1M2UyMmY3NjJjIiwiaWF0IjoxNTk1NDg5MTc0fQ.jfKLhj-4C0sHmSp-JfSdGtdPmFzzgMu3zJi1GD4wj1U";
export const MAPBOX_STYLE =
  "mapbox://styles/yashasvi-jain/ck74sh65j1gji1imwex7eexpu";
